export default __webpack_public_path__ + "static/media/val5.847e0a36.png";